import { chakra, defineRecipe } from '@plurall/elo-v3';

const essayEvolutionChartRecipe = defineRecipe({
  className: 'essay-evolution-card__chart',
  base: {
    minWidth: 0,
    marginTop: 'padding.large',

    '& .chart-root': {
      padding: '0 !important',
      background: 'transparent',
      borderRadius: '0',
    },

    '& .recharts-default-legend': {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      gap: 'gap.large',
      marginTop: 'padding.small',
    },
  },
});

const essayEvolutionPaginationRecipe = defineRecipe({
  className: 'essay-evolution-card__pagination',
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: 'gap.small',
    marginTop: 'padding.small',
  },
});

const essayEvolutionPageIndicatorRecipe = defineRecipe({
  className: 'essay-evolution-card__page-indicator',
  base: {
    color: 'text.secondary',
    fontSize: 'font.size.small',
  },
});

const essayEvolutionTooltipRecipe = defineRecipe({
  className: 'essay-evolution-card__tooltip',
  base: {
    display: 'flex',
    flexDirection: 'column',
    background: 'background.primary',
    border: '1px solid {colors.border.secondary}',
    borderRadius: 'border.radius.3xsmall',
    boxShadow: 'sm',
    paddingBlock: 'padding.3xsmall',
    paddingInline: 'padding.xsmall',
    gap: 'gap.3xsmall',
  },
});

const essayEvolutionTooltipLabelRecipe = defineRecipe({
  className: 'essay-evolution-card__tooltip-label',
  base: {
    fontSize: 'font.size.xsmall',
    color: 'text.secondary',
    marginBottom: 'padding.3xsmall',
    fontWeight: 'font.weight.bold',
  },
});

const essayEvolutionTooltipItemRecipe = defineRecipe({
  className: 'essay-evolution-card__tooltip-item',
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: 'gap.xsmall',
    justifyContent: 'space-between',
    fontSize: 'font.size.small',
    color: 'text.primary',
  },
});

const essayEvolutionTooltipLeftRecipe = defineRecipe({
  className: 'essay-evolution-card__tooltip-left',
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'gap.3xsmall',
  },
});

const essayEvolutionTooltipDotRecipe = defineRecipe({
  className: 'essay-evolution-card__tooltip-dot',
  base: {
    display: 'inline-block',
    width: 'size.8',
    height: 'size.8',
    borderRadius: '50%',
    flex: '0 0 8px',
    alignSelf: 'center',
  },
});

export const EssayEvolutionChartFactory = chakra('div', essayEvolutionChartRecipe);
export const EssayEvolutionPaginationFactory = chakra('div', essayEvolutionPaginationRecipe);
export const EssayEvolutionPageIndicatorFactory = chakra('span', essayEvolutionPageIndicatorRecipe);
export const EssayEvolutionTooltipFactory = chakra('div', essayEvolutionTooltipRecipe);
export const EssayEvolutionTooltipLabelFactory = chakra('div', essayEvolutionTooltipLabelRecipe);
export const EssayEvolutionTooltipItemFactory = chakra('div', essayEvolutionTooltipItemRecipe);
export const EssayEvolutionTooltipLeftFactory = chakra('div', essayEvolutionTooltipLeftRecipe);
export const EssayEvolutionTooltipDotFactory = chakra('span', essayEvolutionTooltipDotRecipe);
